<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
		<div class="o-form -two-columns">


            <div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>


            <div class="o-row -gutter-xs">
                <div class="o-col w-1/3">
                    <div class="o-col__inner -sticky">
                        <h1 class="o-form__title">Compagnies</h1>
                        <Listbox
                            v-bind:listbox="listbox"
                            @selected="setSelected"
                            @set-new-item="setNewItem"
                            @delete-item="deleteItem($event)"
                            @duplicate-item="duplicateItem($event)"
                            @set-search-text="setSearchText('searchCompanyText', $event)"
                            :deletedShowable="true"
                            :showDeleted="showDeleted"
                            @set-show-deleted="showDeleted = $event"
                        />
                    </div>
                </div>

                <div class="o-col w-2/3">
                    <form
                        @submit.prevent="saveItem(form)"
                        autocomplete="off"
                        class="q-pt-sm"
                    >
                        <q-banner rounded inline-actions class="bg-orange-2 q-mb-lg" v-if="isSynced">
                            <template v-slot:avatar>
                                <q-icon name="cloud" color="orange" />
                            </template>
                            Ce compte est synchronisé. Les champs contenant de l'information synchronisée ont été désactivés.
                            <div class="row">
                                <small>
                                    Dernière synchronisation : {{ (form.synced_at) ? form.synced_at : 'jamais' }}
                                </small>
                                <small class="q-ml-auto">
                                    Identifiant de synchronisation : <span>{{ (form.sync_external_id) ? form.sync_external_id : 'n/d' }}</span>
                                </small>
                            </div>
                        </q-banner>
                        <fieldset class="o-form__inner">
                            <div class="o-form__title -save-button">
                                <button type="button" class="o-button -lg" :loading="$apollo.loading" color="primary" v-if="form.id && form.deleted_at"
                                    @click.stop="restoreItem(form)">
                                    Restaurer
                                    <q-icon name="save" class="o-ico -right" />
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary" v-else-if="form.id && !form.deleted_at">
                                    Sauvegarder
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                                <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary"  v-else>
                                    Ajouter
                                    <q-icon name="save" class="o-ico -right" />    
                                </button>
                            </div>
                            <!-- <h2 class="o-form__title">Compagnies</h2> -->
                            <input v-if="form.id" type="hidden" v-model="form.id" />
                            <div class="o-form__item">
                                <Input
                                    v-model="form.name"
                                    placeholder="Nom de la compagnie"
                                    label="Nom"
                                    required=true
                                    error-message="Ce champ est requis"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    :readonly="isSynced"
                                />
                            </div>
                            <div class="o-form__item q-mb-lg">
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.primary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone principal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="tel"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.secondary_phone"
                                    placeholder="(111) 111-1111"
                                    label="Téléphone secondaire"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="tel"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.fax"
                                    placeholder="(111) 111-1111"
                                    label="Télécopieur"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="tel"
                                />
                            </div>
                            <div class="o-form__item q-mb-lg">
                                <Input
                                    v-model="form.website"
                                    placeholder="https://votresite.com"
                                    label="Site Internet"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="url"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.street"
                                    placeholder="Rue"
                                    label="Adresse"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.town"
                                    placeholder="Ville"
                                    label="Ville"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.state"
                                    placeholder="Ex. Qc"
                                    label="Province"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.country"
                                    placeholder="Pays"
                                    label="Pays"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.zipcode"
                                    placeholder="Ex. A1A 1A1"
                                    label="Code postal"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>
                            <!-- <div class="o-form__item -button -multiple">
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="form.id">Sauvegarder</button>
                                <button class="o-button" :loading="$apollo.loading" color="primary" v-if="!form.id">Ajouter</button>
                            </div> -->
                            <div class="o-form__item q-mb-lg">
                            </div>
                            <div class="o-form__item">
                                <CompanyCategoryInput
                                    v-model="form.categories"
                                    label="Catégories de compagnie"
                                    :multiple="true"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                />
                            </div>

                            <div class="o-form__item q-mb-lg">
                            </div>
                            <div class="o-form__item">
                                <Input
                                    v-model="form.contact_email"
                                    placeholder=""
                                    label="Email du contact / panificateur"
                                    :filled="false"
                                    dense
                                    :outlined="true"
                                    type="email"
                                    hint="Ce courriel sera utilisé pour regrouper les notifications des utilisateurs «partenaires» de cette compagnie et notifier le planificateur du partenaire. * Seul le planificateur sera notifié"
                                    :readonly="isSynced"
                                />
                            </div>
                        </fieldset>
                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { COMPANIES, COMPANIESSEARCH } from '@/graphql/company/queries'
    import { COMPANYCATEGORIES } from '@/graphql/category/queries'
    import { UPSERTCOMPANY, DELETECOMPANY, RESTORERECOMPANY } from '@/graphql/company/mutations'
    import { removeNULL, remove__typename } from '@/js/utilities'
// CompanyCategoryInput
    export default {
        name: 'companies',
        apollo: {
            companies: {
                query: COMPANIES,
                fetchPolicy: 'cache-and-network',
                variables() {
                    return {
                        trashed: this.trashed,
                        first: this.perPage
                    }
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(companies) {
                    this.listbox.listItems = Object.assign([], companies.companies.data)
                    this.listbox.listItems.forEach(item => {
                        // console.log('item', item)
                        if(item.categories && item.categories.length>0) item.color = item.categories[0].color;
                    });
                }
            },
            categories: {
                query: COMPANYCATEGORIES,
                fetchPolicy: 'cache-and-network',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(categories) {
                    // console.log(categories)
                    return categories.companyCategories
                    // this.listbox.listItems = Object.assign([], categories.companies.data)
                }
            },
        },
        data(){
            return {
                listbox: {
                    selectedItem: { id: -1 },
                    listItems: {},
                    addButton: 'Nouveau',
                    deleteButton: 'Supprimer',
                    copyButton: 'Copier',
                    searchableQL: 'Rechercher / filtrer'
                },
                searchCompanyText: null,
                form: {},
                perPage: 50,
                showDeleted: false,

                newItem: {
                    // id: 0,
                    // name: null,
                    // primary_phone: null,
                    // secondary_phone: null,
                    // fax: null,
                    // street: null,
                    // town: null,
                    // state: null,
                    // country: null,
                    // zipcode: null,
                    // website: null,
                },
            }
        },
        mounted: async function(){
            this.listbox.selectedItem=Object.assign({}, this.newItem);
            this.form=Object.assign({}, this.newItem);
        },
        computed: {
            trashed() {
                if (this.showDeleted) return 'ONLY'
                return 'WITHOUT'
            },
            isSynced() {
                let isSynced = false
                if(this.$generalSettings.settings.enableUsersSyncModule && this.form.synced_at) isSynced = true
                return isSynced
            },
        },
        watch: {
            'listbox.listItems': function () {
                this.listbox.listItems.forEach(item => {
                    if (this.$generalSettings.settings.enableUsersSyncModule && item.synced_at) {
                        item.icon = "cloud";
                        item.iconColor = 'orange-2';
                    }
                    // if (item.company?.categories.length > 0) item.color = item.company.categories[0].color;
                })
            }
        },
        methods: {
            setSelected(item){
                this.listbox.selectedItem = Object.assign({}, item);
                this.form = remove__typename(Object.assign({}, item));
            },
            setNewItem(){
                this.listbox.selectedItem=Object.assign({}, this.newItem);
                this.form=Object.assign({}, this.newItem);
                this.$nextTick(() => {
                    this.$eventBus.$emit('reset-validation');
                })
            },
            duplicateItem(){
                this.form.id=null;
                this.form.name=this.form.name + ' - copy'
                this.saveItem(this.form);
            },
            deleteItem(form){
                if( form.id==0 ) return this.setNewItem();

                this.$apollo.mutate({
                    mutation: DELETECOMPANY,
                    variables: { ...form },
                    update: () => {
                        if (this.$apollo.queries.companies) this.$apollo.queries.companies.refetch()
                        this.setSelected(null);
                    }
                })
                this.setNewItem();
            },
            saveItem(form) {
                form = removeNULL(form);
                if (form.categories) form.categories = form.categories.map(item => item.id);
                // console.log(form)
                this.$apollo.mutate({
                    mutation: UPSERTCOMPANY,
                    variables: { ...form },
                    update: (store, { data: { upsertCompany } }) => {
                        if (!form.id) {
                            let myVariables = { trashed: this.trashed, first: this.perPage }
                            const data = store.readQuery({ query: COMPANIES, variables: myVariables })
                            data.companies.data.push(upsertCompany);
                            store.writeQuery({
                                query: COMPANIES,
                                data,
                            })
                        }
                        this.setSelected(upsertCompany);
                    }
                }).then((/*data*/) => {
                    this.$q.notify({type: 'positive', message: "Companie : "+form.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                })
            },
            restoreItem(form) {
                this.$apollo.mutate({
                    mutation: RESTORERECOMPANY,
                    variables: {
                        id: form.id
                    },
                    update: (store, { data: { restoreCompany } }) => {
                        if (!form.id) {
                            const data = store.readQuery({ query: COMPANIES })
                            data.companies.push(restoreCompany);
                            store.writeQuery({
                                query: COMPANIES,
                                data,
                            })
                        }
                        this.setSelected(restoreCompany)
                    }
                }).then(() => {
                    this.$q.notify({ type: 'positive', message: "Compagnie : " + form.name, caption: "Informations sauvegardées" })
                }).catch(e => {
                    if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                }).finally(() => {
                })
            },
            setSearchText(prop, searchText) {
                this.setSelected(this.newItem);
                if (searchText && searchText.length > 1) searchText = searchText.trim().split(" ").join("* ") + "*";
                this.fetchSearchText(searchText);
            },
            async fetchSearchText(searchText) {

                if (searchText && searchText != "") {
                    if (this.$apollo.queries.companiesSearch) {
                        this.$apollo.queries.companiesSearch.options.variables.searchText = searchText;
                        this.$apollo.queries.companiesSearch.refresh();
                    } else {

                        let search = searchText.trim().split(" ").join("* ") + "*";
                        search = search.replace(/\*\*/g, '*');

                        this.$apollo.addSmartQuery('companiesSearch', {
                            query: COMPANIESSEARCH,
                            fetchPolicy: 'network-only',
                            error(error) {
                                if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                            },
                            variables: {
                                searchText: search,
                                // trashed: this.trashed,
                                first: this.perPage
                            },
                            update(companiesSearch) {
                                this.listbox.listItems = Object.assign([], companiesSearch.companiesSearch.data)
                                this.listbox.listItems.forEach(item => {
                                    // console.log('item', item)
                                    if (item.categories && item.categories.length > 0) item.color = item.categories[0].color;
                                });

                                return companiesSearch;
                            },

                        })
                    }
                } else {
                    this.$apollo.queries.companies.refresh()
                }
            },

        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
